import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import formatDate from "../../utils/FormatDate";

const PointsHistoryTable = ({ pointsHistory }) => {
  return (
    <Paper elevation={3} sx={{ width: "100%", overflow: "hidden", p: 2 }}>
      {/* <Typography variant='h6' component='div' sx={{ mb: 2 }}>
        Historial de Puntos
      </Typography> */}
      <TableContainer sx={{ maxHeight: "auto" }}>
        <Table stickyHeader aria-label='points history table'>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Fecha</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Descripción</TableCell>
              <TableCell align='center' sx={{ fontWeight: "bold" }}>
                Puntos Anteriores
              </TableCell>
              <TableCell align='center' sx={{ fontWeight: "bold" }}>
                Puntos Ganados/Consumidos{" "}
              </TableCell>
              <TableCell align='center' sx={{ fontWeight: "bold" }}>
                Puntos Actuales
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pointsHistory.map((row, index) => (
              <TableRow key={index} hover>
                <TableCell align='center'>
                  {formatDate(row.created_at)}
                </TableCell>
                <TableCell align='center'>{row.descripcion}</TableCell>
                <TableCell align='center'>{row.puntos_anteriores}</TableCell>
                <TableCell
                  align='center'
                  sx={{ color: row.operador == "+" ? "green" : "red" }}
                >
                  {row.operador}
                  {""} {row.diferencia}
                </TableCell>
                <TableCell align='center'>{row.puntos_actuales}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PointsHistoryTable;
